import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Card,  CardBody, Col, Row } from 'reactstrap';
import { connect } from "react-redux";

import { newLoanActions } from "../../_actions";
import validator from 'validator';
import {
    SlPageTitle,
    SlButton,
    TextInput, 
    SlBranchDisplay,
    SlBusyIndicator,
    SLCardSelectable, 
    SlDropdown,

    SlSectionTitle
} from '../editors';
import { metadataService, ProfileApi, SessionService, userService } from '../../_services';

class FindOffice extends Component {
    static displayName = FindOffice.name;

    constructor(props) {
        super(props);
        this.state = { isToggle: false };

        this.state = {
            branchId: "",
            branchDetails: "",
            Miles: "50",
            // ZipCode: props.zipCode, 
            // UserState: props.userState,
            // city: props.city,
            ZipCode: "", 
            UserState: "",
            city: "",
            locatedOffices: [],
            canFindOffice: false, 
            canMoveNext: false, 
            lastSearch: null,
            locationCounter: 0,
            viewNextDisabled: false,
            milesDropdownOpen: false
            
        };
        this.handleSelectOffice = this.handleSelectOffice.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFindLocation = this.handleFindLocation.bind(this);
        this.viewNextLocations = this.viewNextLocations.bind(this);
        this.viewPreviousLocations = this.viewPreviousLocations.bind(this);
    }

   async componentDidMount() {
        const personalInfo = SessionService.getSession().personalInfo;
        if (personalInfo == null) {
            if (userService.getCurrentUser()) {
                this.setState({isBusy : true})
                await ProfileApi.getExtendedProfileInfo().then(response => {
                    if (response.data) {
                        this.setState({ ZipCode: response.data.postalCode });
                    }
                }).finally(() => this.setState({isBusy : false}));
                this.handleFindLocation();
            }
        }else{
            const { city, postalCode, state } = personalInfo;
            this.setState({
                ZipCode: postalCode, 
                UserState: state,
                city: city,
            }, this.handleFindLocation);
        }
       
    }
  
    handleClick(e) {
        this.setState({ isToggle: !this.state.isToggle });
    }

    setMoveNext(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        let canFindOffice = false; 
        let canMoveNext = false; 
        if(validator.isNumeric(newState.Miles + '') && validator.isPostalCode(newState.ZipCode + '', 'US')){
            canFindOffice = true; 
        }
        if(validator.isNumeric(newState.BranchId + '')){
            canMoveNext = true; 
        }
        return { ...stateChanges, ...{ canFindOffice: canFindOffice, canMoveNext: canMoveNext } };
      }

    handleFindLocation(){
        this.setState({isBusy : true, locatedOffices : [], locationSource: '', BranchId: '', lastSearch: null, locationCounter: 0});
        metadataService. getLocations(this.state.ZipCode, this.state.UserState, this.state.city)
            .then(r => {
                if (r.data) {
                    this.setState({locatedOffices: r.data.branches, locationSource: r.data.source, BranchId: '', isBusy: false, lastSearch:{ZipCode: this.state.ZipCode, Miles: this.state.Miles }});
                } else {
                    this.setState({BranchId: '', isBusy: false, lastSearch:{ZipCode: this.state.ZipCode, Miles: this.state.Miles }});
                }
            });
    }

    handleInputChange(event) {
        let targetName = event.target.name;
        let stateChanges ={}

        stateChanges[targetName] = event.target.value;

        const newState = this.setMoveNext(stateChanges);

        this.setState(newState);
    }

    handleSelectOffice = (event, office) => {
        if(this.props.handleSelectedOffice) {
            this.props.handleSelectedOffice(office);
        } else {
            let targetName = event.target.name;
            let stateChanges ={}

            stateChanges[targetName] = event.target.value;

            const newState = this.setMoveNext(stateChanges);

            this.setState(newState);
        }
    }

    handleSubmit(e) {

        // e.preventDefault();

        const { dispatch } = this.props;

        dispatch(newLoanActions.findABranch(this.state.BranchId, this.state.branchDetails));
    }

    viewNextLocations() {
        const { locationCounter, locatedOffices } = this.state;
        let viewNextDisabled = false;
        if(locationCounter + 2 >= locatedOffices.length - 1) {
            viewNextDisabled = true;
        }
        this.setState({locationCounter: locationCounter + 2, viewNextDisabled});
    }

    viewPreviousLocations() {
        const { locationCounter } = this.state;
        this.setState({locationCounter: locationCounter - 2, viewNextDisabled: false});
    }

    openMilesDropdown = () => {
        this.setState({ milesDropdownOpen: !this.state.milesDropdownOpen });
    }

    render() {
        const { locationCounter, locatedOffices, locationSource } = this.state;

        return (
            <div className="FindOffice mt-0 pt-0">
                <h1 className='text-center Page-Title mt-0'>{metadataService.getLabel('ChooseLoanOffice')}</h1>
                <h6 className='text-center mt-3'>{metadataService.getMessage('ChooseLoanOffice')}</h6>
                <div>
                    <Card>
                        <CardBody className="p-0 m-0">                         
                            <Row className="text-left p-0 m-0">
                                <Col sm={12} md={{ size: 6, offset: 2 }} className="pl-0" >
                                    <TextInput name='ZipCode' showLabel={false} onChange={this.handleInputChange} value={this.state.ZipCode} type="number" maxLength="5"/>
                                </Col>
                                <Col sm={12} md={4} className="pt-3">
                                    <SlButton name="Find_Location" onClick={this.handleFindLocation} disabled={!this.state.canFindOffice} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    <SlBusyIndicator visible={this.state.isBusy}/>
                    <div style={{marginTop: '15px'}}>
                    <div style={{ display: this.state.locatedOffices.length > 0 ? 'block' : 'none' }} className="mt-3 mb-3" >
                        <Row>
                        {locatedOffices.length > 0 && locatedOffices.slice(locationCounter, locationCounter + 2 ).map((office) => {
                            const { selectedBranch } = this.props;
                            const { branchName, city, address1, address2, state, postalCode, phone, sunLoanBranchId } = office; 
                            return (
                                <Col sm='12' md={6} key={office.sunLoanBranchId}>                                   
                                    <SLCardSelectable 
                                    name="BranchId"
                                    value={sunLoanBranchId}
                                    selected={selectedBranch !== null && selectedBranch.sunLoanBranchId === sunLoanBranchId}
                                    onChange={(e) => this.handleSelectOffice(e, office)}
                                    cardBody={<SlBranchDisplay sunLoanBranch={{address1,address2,city,state,postalCode,phone,sunLoanBranchId}}/>}
                                    title={<div className="mb-0 pb-0 mt-0 mb-0">
                                        <small className="mb-0 pb-0 mt-0 mb-0">
                                            {branchName}
                                            {locationSource != "BranchAPI" ? <span data-source={locationSource}>*</span> : ""}
                                        </small>
                                        <p  className="mb-0 pb-0 mt-0 mb-0">{city}</p>
                                    </div>}
                                    />
                                    {/* <SlRadioButton fieldName="BranchId" value={office.sunLoanBranchId} isSelected={selectedBranch !== null && selectedBranch.sunLoanBranchId === office.sunLoanBranchId} onChange={(e) => this.handleSelectOffice(e, office)}>
                                        <SlBranchDisplay sunLoanBranch={office}/>
                                    </SlRadioButton> */}

                                </Col>
                                );
                            
                        })}
                        </Row>
                        {!this.props.hideNext && (
                            <div className="text-center">
                                <SlButton size='lg' name="Next" onClick={this.handleSubmit} disabled={!this.state.canMoveNext} onChange={this.handleInputChange}/>
                                {/* <Button outline color="secondary" size="md" onClick={this.handleSubmit}>Next >></Button> */}
                            </div>
                        )}
                    </div>
                    {this.state.lastSearch && (
                    <div style={{ display : this.state.locatedOffices.length === 0 ? 'block' : 'none' }} className="container text-centered">
                        <p>
                        {metadataService.getMessage("NoLocationFound", this.state.lastSearch.Miles, this.state.lastSearch.ZipCode)}
                        </p>
                    </div>
                    )}</div>
                    {this.state.locatedOffices.length > 0 &&
                        <Row className="text-center mt-3 mb-3 justify-center">
                            <Col   sm={12}>
                            {locationCounter !== 0 && <span className='p-2'><SlButton size='lg'   cssClass='backBtn' name="PreviousResults" disabled={locationCounter === 0} onClick={this.viewPreviousLocations}/></span>}
                            <span className='p-2'><SlButton size='lg'  name="SeeMoreLocations" disabled={this.state.viewNextDisabled} onClick={this.viewNextLocations}/></span>                        
                            </Col>
                        </Row>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { error, errorString } = state.newLoan;
    const { loggedIn } = state.authentication;
    const { token } = state.authentication;
    const zipCode = state.newLoan.postalCode ? state.newLoan.postalCode : state.registration.postalCode;
    const userState = state.newLoan.borrowerState ? state.newLoan.borrowerState : state.registration.state;
    const city = state.newLoan.city ? state.newLoan.city : state.registration.city;

    return {
        error, errorString, token, loggedIn, zipCode, city, userState,
        language: state.users.language
    };
}

FindOffice.proptypes = {
    handleSelectedOffice: PropTypes.func,
    hideNext: PropTypes.bool
}

FindOffice.defaultProps = {
    hideNext: false
}

const connectedFindOffice = connect(mapStateToProps)(FindOffice);
export { connectedFindOffice as FindOffice };


// WEBPACK FOOTER //
// ./src/components/subcomponents/FindOffice.js